import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

const INTERCEPT_METHODS: string[] = ['POST', 'PUT', 'PATCH'];

function trimRecursive(value: any): any {
  if (value === null || value === undefined) {
    return value;
  }
  else if (typeof value === 'string') {
    return value.trim();
  }
  else if (typeof value === 'object') {
    if (Array.isArray(value)) {
      return value.map(v => trimRecursive(v));
    }
    else {
      let newValue: { [key: string]: any } = {};
      for (const key in value) {
        newValue[key] = trimRecursive(value[key]);
      }
      return newValue;
    }
  }
  return value;
}

@Injectable()
export class TrimInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (INTERCEPT_METHODS.includes(request.method)) {
      const contentType = request.headers.get('Content-Type');
      if (contentType && (contentType.startsWith('application/json') || contentType.startsWith('text/json')) && request.body) {
        const obj = typeof request.body === 'string' ? JSON.parse(request.body) : request.body;
        const data = trimRecursive(obj);
        const strData = JSON.stringify(data);
        if (strData !== JSON.stringify(obj)) {
          console.debug('Trimmed strings in request', obj, data);
          request = request.clone({
            body: strData,
          });
        }
      }
    }

    return next.handle(request)
  }
}
